@for (specialProgram of specialPrograms; track $index) {
  <span class="badge badge-warning m-2">
    {{ specialProgram.specialProgramCodeDescription }}
  </span>
}
